import Icon from "@mui/icons-material/ChairAltTwoTone";
import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Exhibitor",
  options: { label: "Exhibitor" },
  name: "exhibitors",
};
